import { isElementTypeContainer } from '@/common/converter/utils/element'

/**
 * element list 에서 CellType 을 반환
 * @param elementList
 * @returns {*|string}
 */
export const getCellType = (elementList = []) => {
  const element = elementList.find(isElementTypeContainer) ?? {}
  const { property } = element

  return property?.uiType ?? ''
}
